import { useQuery } from '@apollo/client';
import queryOpenPayments from '../graphql/queryOpenPayments.graphql';
import queryInvoices from '../graphql/queryInvoices.graphql';
import { getPaymentClient } from '../api/paymentService';
import { CACHE_POLICIES } from '../constants/GraphQL';
import { getBillingClient } from '../api/billingService';
import { hasValidVideolandCookie } from '../helpers/authentication';

const videolandPaymentApiClient = getPaymentClient();
const billingClient = getBillingClient();

export const useInvoices = createUseInvoices();

export function createUseInvoices() {
	return function useInvoices() {
		const isLoggedIn = hasValidVideolandCookie();

		const {
			loading: invoicesLoading,
			error: invoicesError,
			data: invoicesData,
			refetch: refetchInvoices,
			startPolling: startPollingInvoices,
			stopPolling: stopPollingInvoices,
		} = useQuery(queryInvoices, {
			client: billingClient,
			fetchPolicy: CACHE_POLICIES.CACHE_AND_NETWORK,
			skip: !isLoggedIn,
		});

		const {
			data: openPaymentsData,
			error: openPaymentsError,
			refetch: refetchOpenPayments,
			loading: openPaymentsLoading,
		} = useQuery(queryOpenPayments, {
			client: videolandPaymentApiClient,
			fetchPolicy: CACHE_POLICIES.CACHE_AND_NETWORK,
			skip: !isLoggedIn,
		});

		const refetch = () => {
			refetchInvoices();
			refetchOpenPayments();
		};

		return {
			startPollingInvoices,
			stopPollingInvoices,
			openPayments: openPaymentsData?.me.openPayments,
			invoices: invoicesData?.invoices,
			refetch: () => refetch(),
			loading: invoicesLoading || openPaymentsLoading,
			error: invoicesError || openPaymentsError,
		};
	};
}
